import React from 'react';

import Image from '@atlaskit/image';
import { Inline, Text } from '@atlaskit/primitives/compiled';

import { LikeIcon } from '../../constants/icons/like';

export const TopReaction = ({
	emojiUrl,
	emojiName,
	count,
}: {
	emojiUrl?: string | null;
	emojiName?: string | null;
	count: number;
}): React.JSX.Element => {
	const [hasImageError, setHasImageError] = React.useState(false);

	React.useEffect(() => {
		setHasImageError(false);
	}, [emojiUrl]);

	const shouldRenderEmojiImage = !!emojiUrl && !hasImageError;

	return (
		<Inline space="space.050" alignBlock="center">
			{shouldRenderEmojiImage ? (
				<Image
					src={emojiUrl}
					alt={emojiName || 'Like'}
					width={16}
					height={16}
					testId="top-reaction-emoji"
					onError={() => setHasImageError(true)}
				/>
			) : (
				<LikeIcon />
			)}
			<Text size="small" color="color.text.subtlest">
				{count}
			</Text>
		</Inline>
	);
};

export const getTopReaction = ({
	emojiUrl,
	emojiName,
	count,
}: {
	emojiUrl?: string | null;
	emojiName?: string | null;
	count?: number | null;
}): React.JSX.Element | null => {
	if (!count) {
		return null;
	}

	return <TopReaction emojiUrl={emojiUrl} emojiName={emojiName} count={count} />;
};
